module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalValue),
      expression: "internalValue"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    style: ({
      height: (_vm.computedRows * 1.5 + 2.7) + 'em'
    }),
    attrs: {
      "placeholder": _vm.placeholder,
      "id": _vm.uniqueId
    },
    domProps: {
      "value": (_vm.internalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internalValue = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fff6a40!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/f-textarea.vue
// module id = 654
// module chunks = 1